import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { CurrenciesAvailable, MerchantField } from "../../types";

import { excludedCrossBorderTradeIndustries } from "./InterestedInXbtField";

export class CurrenciesAvailableField extends Field<CurrenciesAvailable> {
  constructor(
    model: Merchant,
    opts: Partial<MerchantField<CurrenciesAvailable>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "$AUD",
      propertyName: "currenciesAvailable",
      pickList: ["$AUD", "$CAD", "$NZD", "$USD", "£GBP", "€EUR"],
      uiFieldType: "MultiSelect",
      ...opts,
    });
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;
    const industry = this._model.storeDetails.industry.value;
    const interestedInXBT = this._model.storeDetails.interestedInXBT.value;

    const isApplicableCountry =
      registeredCountry === "Australia" || registeredCountry === "New Zealand";

    if (!industry) {
      return false;
    }

    const canIndustryUseXBT = !excludedCrossBorderTradeIndustries.includes(
      industry
    );
    const isCorrectSalesChannel =
      salesChannel === "Online and In-store" || salesChannel === "Online Only";
    const isInterestedInXBT = interestedInXBT === "Yes";

    if (
      isApplicableCountry &&
      canIndustryUseXBT &&
      isCorrectSalesChannel &&
      isInterestedInXBT
    ) {
      return true;
    }
    return false;
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
